<script>
    import { onMounted } from 'vue';
    import { useVuelidate } from '@vuelidate/core';
    import { required } from '@vuelidate/validators';
    const axios = require('axios');

    export default {
        props: {
            apiUrl: String,
            userApi: String,
            returnUrl: String,
            usernameLabel: String,
            usernameErrorRequired: String,
            usernamePlaceholder: String,
            passwordLabel: String,
            passwordHide: String,
            passwordShow: String,
            passwordPlaceholder: String,
            passwordErrorRequired: String,
            passwordUnknown: String,
            inlogErrorUnvalid: String,
            sendButtonTxt: String,
            userLocked: String
        },
        setup(props) {
            onMounted(() => {
                if (sessionStorage.getItem('user') !== null) {
                    location.href = props.returnUrl;
                }
            });
            return { v$: useVuelidate() }
        },
        data() {
            return {
                username: '',
                password: '',
                data: {
                    typeAlias: 'Success'
                },
                passwordType: 'password'
            }
        },
        validations() {
            return {
                username: { required },
                password: { required }
            }
        },
        methods: {
            togglePassword() {
                if (this.passwordType === 'password') {
                    this.passwordType = 'text';
                } else {
                    this.passwordType = 'password';
                }
            },
            async submitForm() {
                const valid = await this.v$.$validate();
                if (!valid) return
                const response = await this.fetchData(this.apiUrl, 'put');
                if (response.status === 200) {
                    this.data = response.data;
                    if (this.data.typeAlias === 'Success') {
                        const userResponse = await this.fetchData(this.userApi, 'get');
                        if (userResponse && userResponse.data.success) {
                            sessionStorage.setItem('user', JSON.stringify(response.data.member));
                        }
                        location.href = this.returnUrl;
                    }
                }
            },
            async fetchData(url, methodType) {
                let putData = {};
                if (methodType === 'put') {
                    putData = { 'username': this.username, 'password': this.password };
                }
                try {
                    const response = await axios({
                        method: methodType,
                        url: url,
                        data: putData,
                        headers: { 'Content-Type': 'application/json' },
                    })
                    return response;
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }
</script>

<template>
    <form class="login-form" @submit.prevent novalidate>
        <div v-if="data.typeAlias !== 'Success'" class="form-error has-text-white mb-3">
            <i class="fa-solid fa-warning has-text-danger mr-1"></i>
            <template v-if="data.typeAlias === 'PasswordNotSet'">
                {{passwordUnknown}}
            </template>
            <template v-else-if="data.typeAlias === 'UserLocked'">
                {{userLocked}}
            </template>
            <template v-else>
                {{inlogErrorUnvalid}}
            </template>
        </div>
        <div class="field">
            <label class="label has-text-white" for="username">{{usernameLabel}}</label>
            <div class="control has-icons-left mb-1">
                <input class="input" id="username" name="username" :placeholder="usernamePlaceholder" v-model="username" required>
                <span class="icon is-small is-left">
                    <i class="fa-solid fa-user"></i>
                </span>
            </div>
            <span v-if="v$.username.$error" class="form-error has-text-white"><i class="fa-solid fa-warning has-text-danger"></i> {{usernameErrorRequired}}</span>
        </div>
        <div class="field">
            <label class="label has-text-white" for="password">{{passwordLabel}}</label>
            <div class="control has-icons-left has-icons-right mb-1">
                <input class="input" id="password" name="password" :type="passwordType" :placeholder="passwordPlaceholder" v-model="password" required>
                <span class="icon is-small is-left">
                    <i class="fa-solid fa-lock"></i>
                </span>
                <a class="icon is-small is-right has-pointerevents has-text-black" @click="togglePassword" :title="this.passwordType === 'password' ? this.passwordShow : this.passwordHide">
                    <i :class="['fas', this.passwordType === 'password' ? 'fa-eye' : 'fa-eye-slash']"></i>
                </a>
            </div>
            <span v-if="v$.password.$error" class="form-error has-text-white"><i class="fa-solid fa-warning has-text-danger"></i> {{passwordErrorRequired}}</span>
        </div>
        <button class="button is-primary mt-3" @click.prevent="submitForm"><b>{{sendButtonTxt}}</b></button>
    </form>
</template>
